module.exports = __webpack_public_path__ + "static/media/square.db0ea9cc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/square.svg
// module id = 216
// module chunks = 1